export const whatBankData = {
  question: 'Which bank/credit card provider was the money taken from?',
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/00c0550601a3-tooliconbank.jpg',
  },
  id: 'what-bank',
}
